export default __webpack_public_path__ + "files/6c02c0a94bc222d7b9ff517af9d1ca40.svg";